import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { MediaStreamModel } from '@modules/media/models/media-stream.model';
import { TranscriptModel } from '@modules/media/models/transcript.model';

@Component({
  selector: 'mb-stream-player-wrapper',
  templateUrl: './stream-player-wrapper.component.html',
  styleUrls: ['./stream-player-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StreamPlayerWrapperComponent {
  @Input() activeStream!: MediaStreamModel;
  @Input() transcript!: TranscriptModel | null;
  @Input() allowPictureInPicture = true;
  @Input() isEmbedPlayer = false;
  @Input() showBackButton = false;
  @Input() autoplay = false;

  @Output() openMedia = new EventEmitter<any>();
  @Output() streamStopped = new EventEmitter();
  @Output() shareStream = new EventEmitter();
  @Output() backButton = new EventEmitter();

  public OnClosePlayer(): void {
    this.backButton.emit();
  }

  public OnStopStream(): void {
    this.streamStopped.emit();
  }

  public onOpenMedia(resource: any): void {
    this.openMedia.emit(resource);
  }

  public onShareStream(): void {
    this.shareStream.emit();
  }

  public setStreamPlayerConfig(streamErrorData: { errorText: string; showErrorScreen: boolean }): void {
    if (this.activeStream?.playerConfig) {
      this.activeStream.playerConfig.showErrorScreen = streamErrorData.showErrorScreen;
      this.activeStream.playerConfig.errorText = streamErrorData.errorText;
    }
  }
}
